import React, { Suspense, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Spinner from '../../generic-components/Spinner';
import SimplePage from '@/modules/simplePage';
import PageAlert from '@/components/page-alert/page-alert';
import { AppContext } from '@/stateManager';
import { simo } from '@/api/urls';

const GenericErrorPage = (props: any) => {
  const history = useHistory();
  const context = useContext<any>(AppContext);

  // No error no error page for you
  if (!props.display) {
    if (!context.store.apiError) {
      history.push(simo.url());
    }
  }

  return (
    <Suspense fallback={<Spinner />}>
      <div className="container pt-5 pb-5">
        <SimplePage>
          <div className="ys-container-fluid mt-5 mb-5">
            <PageAlert
              display={props.display ? props.display : context.store.apiError}
              alert={props.alert}
            />
          </div>
        </SimplePage>
      </div>
    </Suspense>
  );
};

export default GenericErrorPage;
